export default __webpack_public_path__ + "static/media/back.2dae731e.svg";